import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cc from 'classcat';
import Api from 'services/Api';
import { ContainerQuery } from 'lib/react-container-query';
import { isLoading } from 'lib/redux-utils';
import Countdown from 'components/Countdown';
import FlipClock from 'components/FlipClock';
import Bingo from 'modules/Bingo';
import TicketBuyPanel from 'components/Bingo/TicketBuyPanel';
import MultiSelect from './TicketMultiSelect';
import TicketCount from './src/TicketCount';
import './quickBuy.css';

const SECOND = 1000;

const query = {
  'max-height-390': { maxHeight: 390 },
  'max-height-320': { maxHeight: 320 },
  'max-height-240': { maxHeight: 240 },
  'max-height-180': { maxHeight: 180 }
};

export class _QuickBuy extends Component {
  ticketSelect = (ticketCount) => {
    this.props.autoselectTickets(ticketCount);
  };

  render() {
    const {
      nextAutoSelectedTicketCount,
      inPlay,
      inProgress,
      updateStartDate,
      startDate,
      refName,
      max,
      loading,
      ticketPrice,
      type
    } = this.props;
    const totalPrice = nextAutoSelectedTicketCount && nextAutoSelectedTicketCount * ticketPrice;
    const freeRoom = ticketPrice <= 0;
    const quickBuyClass = cc([
      'quickBuy-panel',
      {
        inPlay: inPlay || inProgress
      }
    ]);
    return (
      <div className={quickBuyClass}>
        <ContainerQuery query={query}>
          {(params) => (
            <div
              className={cc([
                'top',
                params,
                {
                  withCountdown: inPlay || inProgress
                }
              ])}
            >
              <div className="title-section">
                {inPlay || inProgress ? (
                  <span className="quickBuy-panel__title">Buy Tickets for game starting in</span>
                ) : null}
                {inPlay || inProgress ? (
                  <Countdown
                    expirationDate={startDate}
                    onEnd={updateStartDate}
                    updateInterval={SECOND}
                  >
                    <FlipClock />
                  </Countdown>
                ) : null}
                <div className="mrQTicket-wrapper">
                  <TicketCount refName={refName} />
                </div>
              </div>
              {!freeRoom ? (
                <MultiSelect
                  max={max}
                  handleClick={this.ticketSelect}
                  selection={nextAutoSelectedTicketCount}
                  type={type}
                  loading={loading}
                />
              ) : null}
            </div>
          )}
        </ContainerQuery>
        <TicketBuyPanel
          refName={refName}
          className="bottom"
          ticketCount={nextAutoSelectedTicketCount}
          totalPrice={totalPrice}
          whatToBuy={freeRoom ? max : nextAutoSelectedTicketCount}
          free={freeRoom}
          max={max}
          switchTab={!inPlay && !inProgress}
        />
      </div>
    );
  }
}

_QuickBuy.propTypes = {
  refName: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['30', '75', '90']),
  max: PropTypes.number,
  startDate: PropTypes.number,
  nextAutoSelectedTicketCount: PropTypes.number,
  ticketPrice: PropTypes.number,
  autoselectTickets: PropTypes.func,
  updateStartDate: PropTypes.func,
  inPlay: PropTypes.bool,
  loading: PropTypes.bool,
  inProgress: PropTypes.bool
};

_QuickBuy.defaultProps = {
  startDate: 0,
  nextAutoSelectedTicketCount: 0,
  ticketPrice: 0,
  autoselectTickets: null,
  updateStartDate: null,
  type: null,
  inPlay: false,
  inProgress: false,
  loading: false,
  max: null
};

const mapStateToProps = (state, ownProps) => {
  const { refName } = ownProps;
  const startDate = Bingo.selectors.getNextStartDate(state, refName);
  const room = Bingo.selectors.getInstance(state, refName) || {};
  const nextAvailableCount = Bingo.selectors.getAvailableTicketCount(state, refName, 'next');
  return {
    startDate: startDate && new Date(startDate).getTime(),
    nextAutoSelectedTicketCount: Bingo.selectors.getAutoSelectedTicketCount(state),
    max: nextAvailableCount,
    ticketPrice: room.ticketPrice || 0,
    type: room.type,
    inPlay: Bingo.selectors.getInPlay(state, refName),
    loading:
      isLoading(state, Bingo.actionTypes.AT.PURCHASED_TICKETS._) ||
      isLoading(state, Bingo.actionTypes.AT.ASSIGNED_TICKETS._) ||
      isLoading(state, Bingo.actionTypes.AT.QUICK_BUY._) ||
      isLoading(state, Bingo.actionTypes.AT.BUY_SELECTED._),
    inProgress: Bingo.selectors.getInProgress(state, refName)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateStartDate: () =>
    Api.actions.bingo.startDate({ refName: ownProps.refName, instance: 'next' }, undefined, {
      skipSession: true
    })(dispatch), // Debounce
  // this?
  autoselectTickets: (ticketCount) =>
    dispatch(Bingo.actions.autoselectTickets(ownProps.refName, ticketCount))
});

export default connect(mapStateToProps, mapDispatchToProps)(_QuickBuy);
